import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_CONSTANTS } from '../../constant';
import baseQueryWithReauth from 'service/baseQuery/baseQuery';

type ApiResponse<T> = {
  data: T;
  status: number;
  message?: string;
};

export const quizzesQuery = createApi({
  reducerPath: 'quizzesQuery',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    findTopic: builder.query({
      query: () => ({
        url: ENDPOINT_CONSTANTS.QUIZZES_TOPICS,
        method: 'GET'
      }),
      transformResponse: <T>(
        response: ApiResponse<T> | undefined
      ): T | undefined => {
        return response?.data;
      }
    }),
    startQuiz: builder.mutation({
      query: id => ({
        url: `${ENDPOINT_CONSTANTS.START_QUIZ}/${id}`,
        method: 'POST',
        body: {}
      })
    })
  })
});

export const { useLazyFindTopicQuery, useStartQuizMutation } = quizzesQuery;
